import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const FilterInvoice = ({
  search,
  setSearch,
  origenFilter,
  setOrigenFilter,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  showAnulados,
  setShowAnulados,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap", mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, color: "#424242" }}>
            Tipo de documento
          </Typography>

          <FormControl sx={{ minWidth: 240 }}>
            <Select
              value={origenFilter}
              onChange={(e) => setOrigenFilter(e.target.value)}
            >
              <MenuItem value="TODOS">Todos</MenuItem>
              <MenuItem value="FACTURA">Facturas</MenuItem>
              <MenuItem value="NOTA_CREDITO">Notas de crédito</MenuItem>
              <MenuItem value="COMPRA">Compras</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <FormControlLabel
          sx={{ ml: 0.5 }}
          control={
            <Checkbox
              checked={Boolean(showAnulados)}
              onChange={(e) => setShowAnulados(e.target.checked)}
            />
          }
          label={
            <Typography sx={{ fontWeight: 700, color: "#424242" }}>
              Mostrar anulados
            </Typography>
          }
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap", mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, color: "#424242" }}>
            Desde
          </Typography>

          <TextField
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            sx={{ minWidth: 160 }}
            InputLabelProps={{ shrink: true }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, color: "#424242" }}>
            Hasta
          </Typography>

          <TextField
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            sx={{ minWidth: 160 }}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      </Box>

      <TextField
        fullWidth
        placeholder="Buscar por código, número de documento o persona"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default FilterInvoice;